import React from 'react';
import { useState, useEffect } from "react";
import axiosConfig from "../axiosConfig";
import Select from 'react-select';
import Header from '../Header/Header';
import LineGraph from "../Graph/LineGraph";
import MainMenu from '../MainMenu/MainMenu';

const graphColors = [
    "#1f77b4",
    "#d62728",
    "#2ca02c",
    "#9467bd",
    "#ff7f0e",
    "#17becf",
    "#8c564b",
    "#e377c2",
    "#7f7f7f",
    "#bcbd22"
];

const ChannelStatus = () => {

    const [update, setUpdate] = useState(0);
    const [time, setTime] = useState("Daily");
    const [type, setType] = useState("STB");
    const [channels, setchannels] = useState([]);
    const [selectedChannels, setSelectedChannels] = useState([]);
    const [start, setStart] = useState("");
    const [finish, setFinish] = useState("");
    const [lastCleanedDate, setLastCleanedDate] = useState("");
    
    const [label, setlabel] = useState([]);
    const [reachp, setReachp] = useState([]);
    const [tvrp, setTvrp] = useState([]);
    const [share, setShare] = useState([]);
    const [timespentviewer, setTimespentviewer] = useState([]);
    
    const [loading,setloading] = useState(false);

    useEffect(() => {

        axiosConfig.get("/trend/channels").then(rsp => {
            //console.log(rsp.data);
            setchannels(rsp.data.channels);
            //console.log(channels);


        }).catch(err => {

        });

        axiosConfig.get("/lastCleanedDate").then(rsp => {
            setLastCleanedDate(rsp.data.lastCleanedDate);
        }).catch(err => {

        });

    }, [])

    const channelOptions = channels.map(channel => ({ label: channel.name, value: channel.id }));

    const handleChannelChange = (options) => {
        const selected = options || [];
        if(selected.length > 10){
            alert("You can select up to 10 channels");
            setSelectedChannels(selected.slice(0, 10));
            return;
        }
        setSelectedChannels(selected);
    }

    const loadTrendData = () => {
        setloading(false);
        setUpdate(previousUpdate => previousUpdate + 1);

        const requests = selectedChannels.map((channel) => {
            var credentials={ "id": channel.value, "time": time,"type":type };
            if(time === "Custom"){
                credentials.start = start;
                credentials.finish = finish;
            }
            return axiosConfig.post("/trend/general/all",credentials);
        });

        Promise.all(requests)
            .then(responses => {
                const buildDatasets = (key) => responses.map((rsp, index) => ({
                    label: selectedChannels[index].label,
                    data: rsp.data[key],
                    backgroundColor: graphColors[index % graphColors.length],
                    fill: false,
                    pointRadius: 1,
                    borderColor: graphColors[index % graphColors.length],
                    borderWidth: 3
                }));

                setReachp(buildDatasets("reachp"));
                setTvrp(buildDatasets("tvrp"));
                setShare(buildDatasets("share"));
                setTimespentviewer(buildDatasets("timespentviewer"));
                setlabel(responses[0] ? responses[0].data.label : []);
                setloading(true);
            }).catch(err => {
                alert("Server Error");
                setUpdate(0);
            })
    }

    const updater = () => {
        if(selectedChannels.length === 0){
            alert("Please select at least one channel");
            return;
        }
        if(time === "Custom"){
            if(start === "" || finish === ""){
                alert("Please select both start and finish dates");
                return;
            }
            if(new Date(start) > new Date(finish)){
                alert("Start Date is greater than Finish Date");
                return;
            }
            if(lastCleanedDate !== "" && new Date(finish) > new Date(lastCleanedDate)){
                alert("Finish Date is greater than last cleaned data date");
                return;
            }
        }
        loadTrendData();
    }
    return (
        <div><Header title="Trend Analysis-General" />
            <MainMenu menu="trendgeneral" />
            <div class="app-content content" style={{ backgroundColor: "azure", minHeight: "36em" }}>
                <div class="content-overlay"></div>
                <div class="content-wrapper" style={{ backgroundColor: "azure" }} >
                    <div class="content-header row">
                    </div>
                    <div class="content-body">

                    {/* <div class="row">
                        <div class="col-md-12">
                            <div class="card p-1 text-white bg-warning">
                                <div class="card-content">
                                    <div class="card-body">
                                        <div class="float-left">
                                            <p class="white"><strong>Upgrade in Progress</strong></p>
                                        </div>
                                        <div class="float-right">
                                            <p class="card-title"><i class="la la-info-circle"></i> Warning</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}






                        <div class="card">
                            <div class="card-content">
                                <div class="card-body">

                                    <div class="row">
                                        <div class="col-md-5">
                                            <Select
                                                placeholder="Select channels (up to 10)"
                                                isMulti
                                                closeMenuOnSelect={false}
                                                options={channelOptions}
                                                value={selectedChannels}
                                                onChange={handleChannelChange}
                                                isOptionDisabled={(option) => selectedChannels.length >= 10 && !selectedChannels.some(channel => channel.value === option.value)}
                                            />
                                        </div>
                                        <div class="col-md-5">
                                            <select class="custom-select d-block w-100" id="timeFrame" required="" value={time} onChange={(e) => { setTime(e.target.value) }}>
                                                <option value="Daily">Last 24 Hour</option>
                                                <option value="Weekly">Last 7 Days</option>
                                                <option value="Monthly">Last 30 Days</option>
                                                <option value="Yearly">Last 365 Days</option>
                                                <option value="Custom">Custom Date Range</option>
                                            </select>
                                        </div>

                                        <div class="col-md-2">
                                            <button onClick={updater} class="btn btn-info">View</button>
                                        </div>

                                    </div>

                                    <br />

                                    {(() => {
                                        if(time === "Custom"){
                                            return (
                                                <div class="row">
                                                    <div class="col-md-3">
                                                        <fieldset class="form-group form-group-style">
                                                            <label for="trendGeneralStart">Start Date</label>
                                                            <input type="date" class="form-control" id="trendGeneralStart" max={lastCleanedDate} onChange={(e) => { setStart(e.target.value) }} />
                                                        </fieldset>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <fieldset class="form-group form-group-style">
                                                            <label for="trendGeneralFinish">Finish Date</label>
                                                            <input type="date" class="form-control" id="trendGeneralFinish" max={lastCleanedDate} onChange={(e) => { setFinish(e.target.value) }} />
                                                        </fieldset>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <label>Last Cleaned Date</label>
                                                        <input type="text" class="form-control" value={lastCleanedDate} disabled />
                                                    </div>
                                                </div>
                                            )
                                        } else {
                                            return null;
                                        }
                                    })()}

                                    <div class="row">

                                        <div class="col-md-2">
                                            <label>Type (STB/OTT)</label>
                                            <select class="custom-select d-block w-100" disabled onChange={(e) => { setType(e.target.value)}}>
                                                <option value="STB">STB</option>
                                                <option value="">All</option>
                                                <option value="OTT">OTT</option>
                                            </select>
                                        </div>

                                        {/* <div class="col-md-2">
                                            <label>Region</label>
                                            <select class="custom-select d-block w-100" onChange={(e) => { }}>
                                                <option value="">All Region</option>
                                                <option value="Dhaka">Dhaka</option>
                                                <option value="Tangail">Tangail</option>
                                                <option value="Chittagong">Chittagong</option>
                                                <option value="Rajshahi">Rajshahi</option>
                                                <option value="Sylhet">Sylhet</option>
                                                <option value="Mymensingh">Mymensingh</option>
                                                <option value="Khulna">Khulna</option>
                                                <option value="Rongpur">Rongpur</option>
                                                <option value="Barishal">Barishal</option>
                                            </select>
                                        </div>
                                        <div class="col-md-2">
                                            <label>Gender</label>
                                            <select class="custom-select d-block w-100" onChange={(e) => { }}>
                                                <option value="">All Gender</option>
                                                <option value="m">Male</option>
                                                <option value="f">Female</option>
                                            </select>
                                        </div>

                                        <div class="col-md-2">
                                            <label>SEC</label>
                                            <select class="custom-select d-block w-100" onChange={(e) => { }}>
                                                <option value="">All SEC</option>
                                                <option value="a1">Lower Class</option>
                                                <option value="c1">Upper Middle Class</option>
                                                <option value="d1">Lower Middle Class</option>
                                                <option value="b1">Upper Class</option>
                                            </select>
                                        </div>

                                        <div class="col-md-2">
                                            <label>Urban/Rural</label>
                                            <select class="custom-select d-block w-100" onChange={(e) => { }}>
                                                <option value="">Urban & Rural</option>
                                                <option value="u">Urban</option>
                                                <option value="r">Rural</option>
                                            </select>
                                        </div>

                                        <div class="col-md-2">
                                            <div class="price-range">
                                                <div class="form-group">
                                                    <div class="slider-sm slider-success my-1" id="small-slider"></div>
                                                </div>
                                                <div class="price-slider">
                                                    <div class="price_slider_amount mb-2">
                                                        <div class="range-amt"><strong>Age Range : </strong> 15
                                                            - 100</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                                    </div>
                                    
                                </div>
                            </div>
                        </div>


                        <br />


                        <div class="row">
                            <div class="col-md-6">
                                <LineGraph title="Reach (%)" text="Active Channels" loading={loading} labels={label} datasets={reachp} color="blue"  update={update} />

                            </div>
                            <div class="col-md-6">
                                <LineGraph title="Share (%)" text="Active Channels" loading={loading} labels={label} datasets={share}  color="red"  update={update} />

                            </div>

                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <LineGraph title="Time Spent Viewer (Min)" text="Active Channels" loading={loading} labels={label} datasets={timespentviewer} color="violet"  update={update} />

                            </div>
                            <div class="col-md-6">
                                <LineGraph title="TVR (%)" text="Active Channels" loading={loading} labels={label} datasets={tvrp} color="green"  update={update} />

                            </div>

                        </div>

                        
                    </div>
                </div>
            </div>
        </div>



    )
}
export default ChannelStatus;
